import { setBeamHeight, setBeamLoadsF, setBeamLoadsLg, setBeamLoadsNr, setBeamWeightP } from '@reducers/options/beam/actions';
import { setBarrierLoadsExternal, setBarrierLoadsInternal } from '@reducers/options/barrier/actions';
import { setReinforcementNz, setReinforcementType } from '@reducers/options/reinforcement/actions';
import defaultExtraField from '@views/Loads/GeneralLoading/DesignLoading/misc/defaultExtraField';
import loadingParams from '@views/Loads/GeneralLoading/DesignLoading/misc/loadingParams';
import { APP_TYPES, defaultUnits } from '@config';
import { setPanelOptions } from '@reducers/options/panel/actions';
import { mergeDeep, unitTransform } from '@services/helper.service';
import { loadTypes } from './../../../views/Loads/GeneralLoading/DesignLoading/misc/combination.class';
import { countryList, standardList } from './../../../app.values';
import { loadsTabModes } from './loadsTabModes';
import { chLoadingParams } from '@views/Loads/GeneralLoading/CharacteristicsLoading/ch-loading.class';
import { updateDesignLoadCombinationValue, setDesignLoadsDesignValue } from '../design/actions';
import { INTERNAL_TYPES } from '.';
import { seismicityLevels, seismicParams, seismicPerformanceTypes } from '@views/Loads/GeneralLoading/DesignLoading/misc/seismic.class';

export const SET_LOADS_TAB_MODE = 'SET_LOADS_TAB_MODE';
export const ADD_LOADS_COMBINATION = 'ADD_LOADS_COMBINATION';
export const UPDATE_LOADS_COMBINATION = 'UPDATE_LOADS_COMBINATION';
export const SELECT_ALL_LOADS_COMBINATION = 'SELECT_ALL_LOADS_COMBINATION';
export const REMOVE_ALL_SELECTED_LOADS_COMBINATION = 'REMOVE_ALL_SELECTED_LOADS_COMBINATION';
export const SET_ACTIVE_COMBINATION = 'SET_ACTIVE_COMBINATION';
export const TOGGLE_SELECTION_OF_COMBINATION  = 'TOGGLE_SELECTION_OF_COMBINATION';
export const CHANGE_COMBINATION_LOAD_TYPE = 'CHANGE_COMBINATION_LOAD_TYPE';
export const UPDATE_EXTRA_COMBINATION_FIELD = 'UPDATE_EXTRA_COMBINATION_FIELD';
export const RESET_EXTRA_COMBINATION_FIELD = 'RESET_EXTRA_COMBINATION_FIELD';
export const UPDATE_CALCULATE_DESIGN_LOAD_DATA = 'UPDATE_CALCULATE_DESIGN_LOAD_DATA';
export const SET_IMPORT_COMBINATIONS_STATE = 'SET_IMPORT_COMBINATIONS_STATE';
export const SET_IMPORT_COMBINATIONS_DATA = 'SET_IMPORT_COMBINATIONS_DATA';
export const SET_IMPORT_COMBINATIONS_HEADER = 'SET_IMPORT_COMBINATIONS_HEADER';
export const SET_IMPORT_COMBINATIONS_UNIT = 'SET_IMPORT_COMBINATIONS_UNIT';
export const RESET_IMPORT_DATA = 'RESET_IMPORT_DATA';
export const APPLY_IMPORTED_COMBINATIONS = 'APPLY_IMPORTED_COMBINATIONS';

export const SET_BRACKET_ATTACHMENT_LOAD = 'SET_BRACKET_ATTACHMENT_LOAD';
export const SET_BRACKET_ATTACHMENT_LOAD_L = 'SET_BRACKET_ATTACHMENT_LOAD_L';
export const SET_BRACKET_ATTACHMENT_LOAD_LG = 'SET_BRACKET_ATTACHMENT_LOAD_LG';
export const SET_BRACKET_ATTACHMENT_LOAD_F = 'SET_BRACKET_ATTACHMENT_LOAD_F';
export const SET_BRACKET_ATTACHMENT_LOAD_NR = 'SET_BRACKET_ATTACHMENT_LOAD_NR';
export const SET_BRACKET_ATTACHMENT_WEIGHT_P = 'SET_BRACKET_ATTACHMENT_WEIGHT_P';

export const SET_SAFETY_BARRIERS_EXTERNAL_DIRECTION = 'SET_SAFETY_BARRIERS_EXTERNAL_DIRECTION';
export const TOGGLE_SAFETY_BARRIERS_INTERNAL_DIRECTION = 'TOGGLE_SAFETY_BARRIERS_INTERNAL_DIRECTION';
export const SET_SAFETY_BARRIERS_INTERNAL_DIRECTION_TYPE = 'SET_SAFETY_BARRIERS_INTERNAL_DIRECTION_TYPE';
export const SET_SAFETY_BARRIERS_LOAD_BETWEEN_POSTS = 'SET_SAFETY_BARRIERS_LOAD_BETWEEN_POSTS';
export const SET_SAFETY_BARRIERS_LOAD_PER_LENGTH = 'SET_SAFETY_BARRIERS_LOAD_PER_LENGTH';

export const SET_REBAR_REINFORCEMENT_NZ = 'SET_REBAR_REINFORCEMENT_NZ';
export const SET_REBAR_REINFORCEMENT_TYPE = 'SET_REBAR_REINFORCEMENT_TYPE';
export const SET_REBAR_REINFORCEMENT_WORKING_LIFE = 'SET_REBAR_REINFORCEMENT_WORKING_LIFE';

export const RESET_LOADS_STATE = 'RESET_LOADS_STATE';
export const SET_LOADS_STATE = 'SET_LOADS_STATE';
export const SET_CLADDING_DEAD_LOAD = 'SET_CLADDING_DEAD_LOAD';
export const SET_CLADDING_WIND_LOAD = 'SET_CLADDING_WIND_LOAD';
export const SET_CLADDING_BUILDING_DESCRIPTION = 'SET_CLADDING_BUILDING_DESCRIPTION';

export const SET_WOOD_CONNECTION_PATTERN = 'SET_WOOD_CONNECTION_PATTERN';
export const SET_WOOD_CONNECTION_N_VALUE = 'SET_WOOD_CONNECTION_N_VALUE';
export const SET_WOOD_CONNECTION_LOAD_TYPE = 'SET_WOOD_CONNECTION_LOAD_TYPE';
export const SET_WOOD_CONNECTION_LOAD_VALUE = 'SET_WOOD_CONNECTION_LOAD_VALUE';
export const SET_WOOD_CONNECTION_KMOD_FACTOR = 'SET_WOOD_CONNECTION_KMOD_FACTOR';

/*
  Action creators
 */
export function setLoadsTabMode (mode) {
  return (dispatch, getState) => {
    if (mode === loadsTabModes.DESIGN)
      dispatch(setActiveCombination(0));
    else {
      let data = getState().selectors.loads[APP_TYPES.GENERAL_CALCULATION].calculateDesignLoadData;
      var options = {};
      loadingParams.forEach(param => {
        let value = data[chLoadingParams.DEAD_LOAD].partialSafetyFactor * (data[chLoadingParams.DEAD_LOAD][param.key.toLowerCase()] || 0) +
          data[chLoadingParams.LIVE_LOAD].partialSafetyFactor * (data[chLoadingParams.LIVE_LOAD][param.key.toLowerCase()] || 0) +
          data[chLoadingParams.TEMPORARY_LOAD].partialSafetyFactor * (data[chLoadingParams.TEMPORARY_LOAD][param.key.toLowerCase()] || 0);
        value = Math.round(value * 100) / 100;
        mergeDeep(options, {
          animate: {
            [param.action]: {
              [param.animationName]: {
                fixed: !!value,
                value: value || null,
              }
            }
          }
        });
      });
    dispatch(setPanelOptions(options));
    }

    dispatch({ type: SET_LOADS_TAB_MODE, mode });
  };
}
export function addCombination () {
  return (dispatch, getState) => {
    dispatch({ type: ADD_LOADS_COMBINATION, country: getState().main.localization.country });
    dispatch(updateDesignLoadCombinationValue());
  };
}
export function updateCombination (index, options) {
  return (dispatch, getState) => {
    if (options.name && !getState().selectors.loads[getState().main.appType].importState.isImporting) {
      let designLoadingData = getState().selectors.loads[getState().main.appType].designLoadingData;
      // if (getState().selectors.loads[getState().main.appType].importState.isImporting)
      //   designLoadingData = getState().selectors.loads[getState().main.appType].importState.data;
      // else
      //   designLoadingData = getState().selectors.loads[getState().main.appType].designLoadingData;

      // prevent duplicate names
      for (let i = 0; i < designLoadingData.length; i++){
        if (options.name === designLoadingData[i].name)
          delete options.name; 
      }
      
      if (options.name) {
        if (designLoadingData[index].name === getState().selectors.design[getState().main.appType].loads.design) {
            dispatch(setDesignLoadsDesignValue(options.name));
        }
      }
    }
    
    dispatch({ type: UPDATE_LOADS_COMBINATION, index, options });
  };
}
export function selectAllCombination (value) {
  return (dispatch) => {
    dispatch({ type: SELECT_ALL_LOADS_COMBINATION, value });
    dispatch(updateDesignLoadCombinationValue());
  };
}
export function removeSelected () {
  return (dispatch) => {
    dispatch({ type: REMOVE_ALL_SELECTED_LOADS_COMBINATION });
    dispatch(updateDesignLoadCombinationValue());
  };
}
export function setActiveCombination (index) {
  return (dispatch, getState) => {
    dispatch({ type: SET_ACTIVE_COMBINATION, index });
    let item;
    var options = {};
    if (getState().selectors.loads[APP_TYPES.GENERAL_CALCULATION].importState.isImporting) {
      item = getState().selectors.loads[APP_TYPES.GENERAL_CALCULATION].importState.data[index];
      let headers = getState().selectors.loads[APP_TYPES.GENERAL_CALCULATION].importState.headers;
      item = item.switchHeadersOrder(headers);
    } else {
      item = getState().selectors.loads[APP_TYPES.GENERAL_CALCULATION].designLoadingData[index];
    }
    
    loadingParams.forEach(param => 
      mergeDeep(options, {
        animate: {
          [param.action]: {
            [param.animationName]: {
              fixed: true, // !!item[param.key],
              value: item[param.key] || null,
            }
          }
        }
      })
    );
    dispatch(setPanelOptions(options));
  };
}
export function toggleSelectionOfCombination (index) {
  return (dispatch) => {
    dispatch({ type: TOGGLE_SELECTION_OF_COMBINATION, index });
    dispatch(updateDesignLoadCombinationValue());
  };
}
export function chnageCombinationLoadType (index, value) {
  return (dispatch) => {
    dispatch({ type: CHANGE_COMBINATION_LOAD_TYPE, index, value });
    dispatch(resetExtraCombinationField(index, defaultExtraField[value]));
  };
}
export function updateExtraCombinationField (index, options) {
  return (dispatch, getState) => {
    if (Number(getState().main.localization.designStandard) === standardList['AS5216']) {
      if (options.hasOwnProperty(seismicParams.SEISMICITY_LEVEL)) {
        if (options[seismicParams.SEISMICITY_LEVEL] === seismicityLevels.FIRST.toString()) {
          options[seismicParams.SEISMIC_PERFORMANCE] = seismicPerformanceTypes.C1;
        }
        if (options[seismicParams.SEISMICITY_LEVEL] === seismicityLevels.SECOND.toString()) {
          options[seismicParams.SEISMIC_PERFORMANCE] = seismicPerformanceTypes.C2;
        }
      }
      else if (options.hasOwnProperty(seismicParams.SEISMIC_PERFORMANCE) && 
                getState().selectors.loads['general-calculation'].designLoadingData[index]
                          .extraField[seismicParams.SEISMICITY_LEVEL] !== seismicityLevels.ZERO.toString()) 
      {
        if (options[seismicParams.SEISMIC_PERFORMANCE] === seismicPerformanceTypes.C1) {
          options[seismicParams.SEISMICITY_LEVEL] = seismicityLevels.FIRST.toString();
        }
        if (options[seismicParams.SEISMIC_PERFORMANCE] === seismicPerformanceTypes.C2) {
          options[seismicParams.SEISMICITY_LEVEL] = seismicityLevels.SECOND.toString();
        }
      }
    }
    dispatch({ type: UPDATE_EXTRA_COMBINATION_FIELD, index, options });
  };
}
export function resetExtraCombinationField (index, options) {
  return { type: RESET_EXTRA_COMBINATION_FIELD, index, options };
}
export function updateCalculateDesignLoadData (options) {
  return { type: UPDATE_CALCULATE_DESIGN_LOAD_DATA, options };
}

export function setImportState(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_IMPORT_COMBINATIONS_STATE, value });
    if (!value) {
      dispatch({ type: RESET_IMPORT_DATA });
      if (getState().selectors.loads[APP_TYPES.GENERAL_CALCULATION].loadsTabMode === loadsTabModes.DESIGN) {
        getState().selectors.loads[getState().main.appType].designLoadingData.forEach((c, idx) => {
          if (c.isActive)
            dispatch(setActiveCombination(idx));
        });
      }
    } else {
      dispatch(setImportUnit({
        load: getState().main.units.load,
        moment: getState().main.units.moment
      }));
    }
  };
}
export function setImportData(data, headers) {
  return (dispatch) => {
    dispatch(setImportState(true));
    dispatch({ type: SET_IMPORT_COMBINATIONS_DATA, data, headers });
    if (data.length && data.length > 0)
      dispatch(setActiveCombination(0));
  };
}
export function setImportHeader(idx, value) {
  return (dispatch, getState) => {
    let headers = getState().selectors.loads[getState().main.appType].importState.headers;
    let otherHeader = headers[idx]; // might contain - character
    // loadingParams: Nx, Vx, Vy, Mz, Mx, My - used to find which are load and which are moment units
    let otherHeaderNameIdx = loadingParams.findIndex(p => otherHeader.includes(p.key));
    let crtHeaderNameIdx = loadingParams.findIndex(p => value.includes(p.key));
    if ((otherHeaderNameIdx < 3 && crtHeaderNameIdx >= 3) || (otherHeaderNameIdx >= 3 && crtHeaderNameIdx < 3)) {
      let crtHeaderValueIdx = headers.findIndex(h => h.includes(value.replace('-', '')));
      let loadUnit = getState().selectors.loads[getState().main.appType].importState.units.load;
      let momentUnit = getState().selectors.loads[getState().main.appType].importState.units.moment;
      let loadIdx = crtHeaderNameIdx < 3 ? crtHeaderValueIdx : idx;
      let momentIdx = crtHeaderNameIdx < 3 ? idx : crtHeaderValueIdx;
      // the loads are saved in the default units; when switching the loads between different unit types convert back to the original values
      let newData = getState().selectors.loads[getState().main.appType].importState.data.map(item => {
        item[loadingParams[loadIdx].key] = 
          unitTransform(+item[loadingParams[loadIdx].key] || 0, false).from(defaultUnits.LOAD).to(loadUnit);
        item[loadingParams[loadIdx].key] = 
          unitTransform(+item[loadingParams[loadIdx].key] || 0, false).from(momentUnit).to(defaultUnits.MOMENT);
        item[loadingParams[momentIdx].key] = 
          unitTransform(+item[loadingParams[momentIdx].key] || 0, false).from(defaultUnits.MOMENT).to(momentUnit);
        item[loadingParams[momentIdx].key] = 
          unitTransform(+item[loadingParams[momentIdx].key] || 0, false).from(loadUnit).to(defaultUnits.LOAD);
        return item;
      });

      dispatch({ 
        type: SET_IMPORT_COMBINATIONS_DATA, 
        data: newData, 
        headers
      });
    }

    dispatch({ type: SET_IMPORT_COMBINATIONS_HEADER, idx, value });
    // update 3D view loads
    dispatch(setActiveCombination(getState().selectors.loads[getState().main.appType].activeCombinationIndex)); 
  };
}
export function setImportUnit(value) {
  return (dispatch, getState) => {
    let newData = Array.from(getState().selectors.loads[getState().main.appType].importState.data);
    let headers = getState().selectors.loads[getState().main.appType].importState.headers;
    if (value.hasOwnProperty('load')) {
      let prevLoadUnit = getState().selectors.loads[getState().main.appType].importState.units.load;
      if (value.load !== prevLoadUnit) {
        newData.forEach(item => {
          for (let i = 0; i < 3; i++) {
            let loadIdx = headers.findIndex(h => h.includes(loadingParams[i].key));
            item[loadingParams[loadIdx].key] = 
              unitTransform(+item[loadingParams[loadIdx].key] || 0, false).from(defaultUnits.LOAD).to(prevLoadUnit);
            item[loadingParams[loadIdx].key] = 
              unitTransform(+item[loadingParams[loadIdx].key] || 0, false).from(value.load).to(defaultUnits.LOAD);
          }
        });
      }
    }
    if (value.hasOwnProperty('moment')) {
      let prevMomentUnit = getState().selectors.loads[getState().main.appType].importState.units.moment;
      if (value.moment !== prevMomentUnit) {
        newData.forEach(item => {
          for (let i = 3; i < 6; i++) {
            let momentIdx = headers.findIndex(h => h.includes(loadingParams[i].key));
            item[loadingParams[momentIdx].key] = 
              unitTransform(+item[loadingParams[momentIdx].key] || 0, false).from(defaultUnits.MOMENT).to(prevMomentUnit);
            item[loadingParams[momentIdx].key] = 
              unitTransform(+item[loadingParams[momentIdx].key] || 0, false).from(value.moment).to(defaultUnits.MOMENT);
          }
        });
      }
    }
    dispatch({ 
      type: SET_IMPORT_COMBINATIONS_DATA, 
      data: newData, 
      headers
    });
    if (newData.length && newData.length > 0)
      dispatch(setActiveCombination(getState().selectors.loads[getState().main.appType].activeCombinationIndex)); 
    dispatch({ type: SET_IMPORT_COMBINATIONS_UNIT, value });
  };
}
export function applyImport() {
  return (dispatch) => {
    dispatch({ type: APPLY_IMPORTED_COMBINATIONS });
    dispatch(setImportState(false));
    dispatch(updateDesignLoadCombinationValue());
  };
}

export function setBracketAttachmentLoad (value, key) {
  return { type: SET_BRACKET_ATTACHMENT_LOAD, value, key };
}
export function setBracketAttachmentLoadL (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BRACKET_ATTACHMENT_LOAD_L, value });

    dispatch(setBeamHeight(value));

    if (getState().selectors.loads[getState().main.appType].lg > value) {
      dispatch(setBracketAttachmentLoadLg(value));
    }
  };
}
export function setBracketAttachmentLoadLg (value) {
  return dispatch => {
    dispatch({ type: SET_BRACKET_ATTACHMENT_LOAD_LG, value });

    dispatch(setBeamLoadsLg(value));
  };
}
export function setBracketAttachmentLoadF (value) {
  return dispatch => {
    dispatch({ type: SET_BRACKET_ATTACHMENT_LOAD_F, value });

    dispatch(setBeamLoadsF(value));
  };
}
export function setBracketAttachmentLoadNr (value) {
  return dispatch => {
    dispatch({ type: SET_BRACKET_ATTACHMENT_LOAD_NR, value });

    dispatch(setBeamLoadsNr(value));
  };
}
export function setBracketAttachmentWeightP (value) {
  return dispatch => {
    dispatch({ type: SET_BRACKET_ATTACHMENT_WEIGHT_P, value });

    dispatch(setBeamWeightP(value));
  };
}

export function setSafetyBarrierExternalDirection (typeValue, value, isCustom) {
  return dispatch => {
    dispatch({ type: SET_SAFETY_BARRIERS_EXTERNAL_DIRECTION, typeValue, value });

    dispatch(setBarrierLoadsExternal(value, isCustom));
  };
}

export function toggleSafetyBarriersInternalDirection(value) {
  return dispatch => {
    dispatch({ type: TOGGLE_SAFETY_BARRIERS_INTERNAL_DIRECTION, value });
    dispatch(updateSafetyBarriersInternalLoads());
  };
}
export function setSafetyBarrierInternalDirectionType(value) {
  return dispatch => {
    dispatch({ type: SET_SAFETY_BARRIERS_INTERNAL_DIRECTION_TYPE, value });
    dispatch(updateSafetyBarriersInternalLoads());
  };
}
export function setSafetyBarrierLoadBetweenPosts(value) {
  return dispatch => {
    dispatch({ type: SET_SAFETY_BARRIERS_LOAD_BETWEEN_POSTS, value });
    dispatch(updateSafetyBarriersInternalLoads());
  };
}
export function setSafetyBarrierLoadPerLength(value) {
  return dispatch => {
    dispatch({ type: SET_SAFETY_BARRIERS_LOAD_PER_LENGTH, value });
    dispatch(updateSafetyBarriersInternalLoads());
  };
}
function updateSafetyBarriersInternalLoads() {
  return (dispatch, getState) => {
    let loads = getState().selectors.loads[getState().main.appType];
    dispatch(setBarrierLoadsInternal(
      loads.internalDirection.type === INTERNAL_TYPES.CUSTOM_BETWEEN_POSTS ?
        loads.internalDirection.loadBetweenPosts : 
        loads.internalDirection.loadPerLength, 
      loads.hasInternalDirection));
  };
}

export function setRebarReinforcementNz (value) {
  return dispatch => {
    dispatch({ type: SET_REBAR_REINFORCEMENT_NZ, value });

    dispatch(setReinforcementNz(value));
  };
}
export function setRebarReinforcementType (value) {
  return dispatch => {
    dispatch({ type: SET_REBAR_REINFORCEMENT_TYPE, value });

    dispatch(setReinforcementType(value));
  };
}
export function setRebarReinforcementWorkingLife(value) {
  return dispatch => {
    dispatch({ type: SET_REBAR_REINFORCEMENT_WORKING_LIFE, value});
  };
}
export const setCladdingDeadLoad = (value) => ({
  type: SET_CLADDING_DEAD_LOAD,
  value
});
export const setCladdingWindLoad = (options) => ({
  type: SET_CLADDING_WIND_LOAD,
  options
});
export const setCladdingBuildingDimensions = (dimensions) => ({
  type: SET_CLADDING_BUILDING_DESCRIPTION,
  dimensions
});
export function resetLoadsState (appType) {
  return (dispatch, getState) => {
    dispatch({ type: RESET_LOADS_STATE, appType: appType || getState().main.appType });
    if (appType === APP_TYPES.GENERAL_CALCULATION) {
      dispatch(addCombination());
      dispatch(setActiveCombination(0));
    }

    let designStandard = Number(getState().main.localization.designStandard);
    if (Number(getState().main.localization.country) === countryList["New Zealand"] && appType === APP_TYPES.GENERAL_CALCULATION &&
      (designStandard === standardList["EU"] || designStandard === standardList["ICC.Post"])) 
      dispatch(chnageCombinationLoadType(0, loadTypes.SEISMIC));
  };
}

export function setLoadsState(state) {
  return { type: SET_LOADS_STATE, state };
}

export function setWoodConnectionPattern(value) {
  return {
    type: SET_WOOD_CONNECTION_PATTERN,
    value
  };
}

export function setWoodConnectionNValue(value) {
  return {
    type: SET_WOOD_CONNECTION_N_VALUE,
    value
  };
}

export function setWoodConnectionLoadType(value) {
  return {
    type: SET_WOOD_CONNECTION_LOAD_TYPE,
    value
  };
}

export function setWoodConnectionLoadValue(value) {
  return {
    type: SET_WOOD_CONNECTION_LOAD_VALUE,
    value
  };
}

export function setWoodConnectionKmodFactor(value) {
  return { type: SET_WOOD_CONNECTION_KMOD_FACTOR, value };
}



// WEBPACK FOOTER //
// ./src/reducers/selectors/loads/actions.js